import React, { useState } from 'react'
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import { useTheme } from '../../../components/hooks/useTheme';
import EmailValidatedComponent from '../../../components/EmailValidatedComponent';

type Props = {
    mailChimpKey: string;
    setMailChimpKey: (value: string) => void;
    mailgunSender: string;
    setMailgunSender: (value: string) => void;
    mailgunDomain: string;
    setMailgunDomain: (value: string) => void;
    googleAnalyticsKey: string;
    setGoogleAnalyticsKey: (value: string) => void;
    extraCcUsersForSupportTickets: string;
    setExtraCcUsersForSupportTickets: (value: string) => void;
    disabled: boolean;
}

const Integration = ({
    mailChimpKey,
    setMailChimpKey,
    mailgunSender,
    setMailgunSender,
    mailgunDomain,
    setMailgunDomain,
    googleAnalyticsKey,
    setGoogleAnalyticsKey,
    extraCcUsersForSupportTickets,
    setExtraCcUsersForSupportTickets,
    disabled
}: Props) => {
    const { themeStyles } = useTheme();
    const [isIntegrations, setIsIntegrations] = useState<boolean>(true);

    return (
        <div>
            <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                onClick={() => setIsIntegrations(!isIntegrations)}
            >
                {isIntegrations ? (
                    <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                ) : (
                    <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                )}{" "}
                <div className="w-full flex flex-row justify-between items-center">
                    <div style={{ color: themeStyles.topBar.textColor }}>Integration Settings</div>
                </div>
            </h5>
            <hr />

            {isIntegrations &&
                <div className="w-full px-2 pt-4">
                    <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-4">
                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>MailChimp Key</label>
                                <input
                                    type="text"
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                    value={mailChimpKey}
                                    disabled={disabled}
                                    onChange={(e) => setMailChimpKey(e.target.value)}
                                    required
                                />
                            </div>

                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mailgun Sender</label>
                                <EmailValidatedComponent
                                    text={mailgunSender}
                                    setText={setMailgunSender}
                                    required={true}
                                    disabled={disabled}
                                />
                            </div>

                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Google Analytics Key</label>
                                <input
                                    type="text"
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                    value={googleAnalyticsKey}
                                    disabled={disabled}
                                    onChange={(e) => setGoogleAnalyticsKey(e.target.value)}
                                    required
                                />
                            </div>

                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Extra CC Users For Support Tickets</label>
                                <input
                                    type="text"
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                    value={extraCcUsersForSupportTickets}
                                    disabled={disabled}
                                    onChange={(e) => setExtraCcUsersForSupportTickets(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mailgun Domain</label>
                                <input
                                    type="text"
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                    value={mailgunDomain}
                                    disabled={disabled}
                                    onChange={(e) => setMailgunDomain(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Integration